import { Controller } from '@hotwired/stimulus'

export default class DobController extends Controller {
  static targets = ['day', 'month', 'year']

  connect() {
    this.updateDays()
  }

  updateDays() {
    const month = Number.parseInt(this.monthTarget.value)
    const year = Number.parseInt(
      this.yearTarget.value || new Date().getFullYear()
    )
    const lastDay = new Date(year, month, 0).getDate()

    const currentValue = Number.parseInt(this.dayTarget.value)
    if (lastDay) {
      this.dayTarget.innerHTML = '<option value="">Day</option>'
      for (let i = 1; i <= lastDay; i++) {
        const option = document.createElement('option')
        option.value = i
        option.innerText = i
        if (i === currentValue) option.selected = true
        this.dayTarget.appendChild(option)
      }
    }
  }
}
